import type { SVGProps } from 'react';

type NavIconProps = SVGProps<SVGSVGElement>;

export function ShoppingBagIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M6 8h12l-1.2 11H7.2L6 8Z" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" />
    </svg>
  );
}

/** Multi-storefront — public `/shops` directory tab. */
export function ShopsDirectoryIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M3 10h7v11H3zM14 10h7v11h-7z" />
      <path d="M3 10 5.5 5h2L10 10M14 10l2.5-5h2L21 10" />
      <path d="M5.5 14h2M16.5 14h2" />
    </svg>
  );
}

export function ReceiptIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M7 4h10v16l-2-1.5L13 20l-2-1.5L9 20 7 18.5V4Z" />
      <path d="M10 9h4M10 12h4M10 15h2" />
    </svg>
  );
}

export function HeartHandIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M12 21s-6.5-4.2-8.5-7.4C1.5 10.4 3.2 7 6.4 7c1.7 0 3.1.9 3.9 2.1C11.1 7.9 12.5 7 14.2 7 17.4 7 19.1 10.4 16.5 13.6 14.5 16.8 12 21 12 21Z" />
      <path d="M12 14v4M10.5 15.5 12 14l1.5 1.5" />
    </svg>
  );
}

export function UserCircleIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20c1.5-3 4-4.5 7-4.5s5.5 1.5 7 4.5" />
    </svg>
  );
}

/** Ticket / coupon — Kupóny tab and account-home overflow. */
export function CouponIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1.25a1.75 1.75 0 1 0 0 3.5V16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1.25a1.75 1.75 0 1 0 0-3.5V8Z" />
      <path d="M9.5 6.5v11" strokeDasharray="2.25 2.5" />
      <circle cx="14.75" cy="12" r="1.6" />
    </svg>
  );
}

export function MenuIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M5 7h14M5 12h14M5 17h14" />
    </svg>
  );
}

export function HomeIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M3 10.5 12 3l9 7.5" />
      <path d="M5 9.5V21h14V9.5" />
    </svg>
  );
}

export function ScanIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M4 7V4h3M17 4h3v3M20 17v3h-3M7 20H4v-3" />
      <path d="M7 12h10" />
    </svg>
  );
}

export function HistoryIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M3 12a9 9 0 1 0 3-6.7" />
      <path d="M3 4v5h5" />
      <path d="M12 7v5l3 2" />
    </svg>
  );
}

export function RefreshIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M4 12a8 8 0 0 1 13.7-5.7M20 12a8 8 0 0 1-13.7 5.7" />
      <path d="M16 4h4v4M4 20v-4h4" />
    </svg>
  );
}

/** Sign-out / leave-session glyph for profile chrome menu. */
export function SignOutIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4" />
      <path d="M16 8l4 4-4 4" />
      <path d="M20 12H10" />
    </svg>
  );
}

/** Disclosure chevron for profile chrome menu rows that navigate. */
export function ChevronRightIcon({ className, ...props }: NavIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.35"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M8 5.25 13.25 10 8 14.75" />
    </svg>
  );
}
